/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable react/button-has-type */
/* eslint-disable jsx-a11y/media-has-caption */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import type { RefObject } from "react";
import React, { useEffect } from "react";
import { X } from "lucide-react";


interface CustomModalProps {
  isOpen: boolean; // Determines if the modal is open
  onClose: () => void; // Function to handle closing the modal
  selectedVideo: string | null; // The selected video object or null
  videoRef: RefObject<HTMLVideoElement>; // Ref for the video element
  videoTitle: string; // Title of the selected video
};

const CustomModal: React.FC<CustomModalProps> = ({
  isOpen,
  onClose,
  selectedVideo,
  videoRef,
  videoTitle
}) => {
  useEffect(() => {
    if (isOpen && videoRef.current) {
      void videoRef.current.play();
    }
  }, [isOpen, videoRef]);

  useEffect(() => {
    const handleEscape = (e: { key: string; }) => {
      if (e.key === "Escape") {
        onClose()
      }
    }

    if (isOpen) {
      window.addEventListener("keydown", handleEscape)
    }

    return () => {
      window.removeEventListener("keydown", handleEscape)
    }
  }, [isOpen, onClose])

  if (!isOpen) return null;

   // Convert YouTube URL to embed URL
   const getEmbedUrl = (url: string) => {
    if (!url) return ""
    const videoId = url.split("v=")[1]
    return `https://www.youtube.com/embed/${videoId}`
  }

  return (
    <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg w-full max-w-4xl mx-4 relative transform transition-all duration-300 ease-in-out">
        {/* Header */}
        <div className="flex items-center justify-between p-4 border-b">
        
          <button
            aria-label="Close modal"
            className="text-gray-400 hover:text-gray-600 transition-colors"
            onClick={onClose}
          >
            <X className="h-6 w-6" />
          </button>
        </div>

        {/* Video Player */}
        <div className="aspect-video w-full">
        {selectedVideo ? <iframe
              src={getEmbedUrl(selectedVideo)}
              className="w-full h-full"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              title={videoTitle}
            /> : null}
        </div>

        {/* Video Information */}
        {selectedVideo ? <div className="p-4">
            <h3 className="text-lg font-semibold mb-2">{videoTitle}</h3>          
          </div> : null}
      </div>
    </div>
  );
};

export default CustomModal;
